import { CometChatUIKit, CometChatUIKitLoginListener } from "@cometchat/chat-uikit-react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export async function checkMatterStatus() {
  const user = CometChatUIKitLoginListener.getLoggedInUser();
  if (!user) return;

  const role = user?.getRole();
  if (role !== "client") {
    console.log("Skipping matter check (not a client)");
    return;
  }

  const metadata = user?.getMetadata() as any;
  const email = metadata?.["@private"]?.email || metadata?.email;

  if (!email) {
    console.warn("User email not found in metadata");
    return;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/check-matter-status`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email })
    });

    const data = await response.json();
    console.log("Matter status response:", data);

    if (response.status === 403) {
      console.warn("Matter closed. Redirecting to login...");

      // Show toast with error from API if exists, else fallback message
      toast.error(data?.error || "Your matter has been closed. Chat access disabled.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      // Delay logout and redirect so user sees the toast
      setTimeout(async () => {
        try {
          await CometChatUIKit.logout();
        } catch (e) {
          console.error("Logout failed:", e);
        }

        localStorage.removeItem(`chat_notifications_${user.getUid()}`);
        window.location.href = "/login";
      }, 3000);
    }

  } catch (error: any) {
    // Show toast for network or fetch errors
    toast.error(error?.message || "Matter status check failed", {
      position: "top-right",
      autoClose: 3000,
    });
    console.error("Matter status check failed:", error);
  }
}